import { View } from "react-native";
import empty_album_state from "src/assets/lottie/empty_album_state/empty_album_state.lottie";
import Lottie from "src/components/Lottie";
import { radiusLarge } from "src/styles/radius";
import { paddingLarge, paddingMedium } from "src/styles/spacing";
import { BlurView, Text } from "src/swsh-native";

const NoPhotosHidden = () => {
	return (
		<View
			style={[
				{
					width: "100%",
					height: "100%",
					alignItems: "center",
					justifyContent: "center",
				},
			]}
		>
			<Lottie
				source={empty_album_state}
				style={{
					position: "absolute",
					width: "80%",
					height: "80%",
				}}
			/>
			<BlurView
				style={{
					paddingHorizontal: paddingLarge,
					paddingVertical: paddingLarge,
					borderRadius: radiusLarge,
					rowGap: paddingMedium,
					maxWidth: 400,
					alignItems: "center",
				}}
			>
				<Text
					semiLarge
					semibold
					style={{
						textAlign: "center",
					}}
				>
					No hidden photos or videos
				</Text>
				<Text
					style={{
						textAlign: "center",
					}}
				>
					Media you hide will be removed from the album and can be found here.
					Participants cannot see hidden photos and videos.
				</Text>
			</BlurView>
		</View>
	);
};
export default NoPhotosHidden;
